import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface IAuthStateSlice {
  isAuthorized?: boolean;
  isPinAuthorized?: boolean;
  authState?: string;
  error?: string;
  user?: User;
  loginState?: string;
  challenge?: string;
  userPreference?: UserPreference;
  pinTries: number;
  pinLockTime: number | null;
  hasNoAccess: boolean | null;
  smsData?: {
    phoneNumber: string;
    isVerified: boolean;
  };
  betaFeaturesAllowedList?: string[];
  betaFeaturesLoaded?: boolean;
}

const name = "Auth";

export const initialState: IAuthStateSlice = {
  isAuthorized: false,
  isPinAuthorized: false,
  authState: "pending",
  error: "",
  user: undefined,
  loginState: "login",
  userPreference: undefined,
  pinTries: 0,
  pinLockTime: null,
  hasNoAccess: null,
  smsData: undefined,
  betaFeaturesAllowedList: [],
  betaFeaturesLoaded: false,
};

export const authSlice = createSlice({
  name,
  initialState,
  reducers: {
    setAuthState: (state, action: PayloadAction<Partial<IAuthStateSlice>>) => ({
      ...state,
      ...action.payload,
    }),
    setPinTries: (state, action: PayloadAction<number>) => {
      state.pinTries = action.payload;
    },
    setPinLockTime: (state, action: PayloadAction<number | null>) => {
      state.pinLockTime = action.payload;
    },
    setUser: (state, action: PayloadAction<Partial<User>>) => {
      state.user = { ...state.user, ...action.payload } as User;
    },
  },
});

export const { setAuthState, setPinTries, setPinLockTime, setUser } =
  authSlice.actions;

export default authSlice.reducer;
